<div [formGroup]="bookingForm">

  <div class="row">
    @if (!bookingConfigAlreadyExist) {
      <p class="text-error"
         translate="error.configuration.noBookingConfiguration"></p>
    }
  </div>

  <div class="row">

    <h5 translate="services.booking.baseConfigurationSubtitle"></h5>

    <!-- Booking Mode -->
    <div class="col-12">
      <label class="form-label" translate="services.booking.bookingMode"></label>

      <div>
        <div class="btn-group" role="group">
          <input class="btn-check" type="radio"
                 [formControl]="bookingMode"
                 [value]="BookingMode.Free">
          <label class="btn btn-toggle btn-toggle-left h-auto"
                 [ngClass]="{ active: bookingMode.value === BookingMode.Free }"
                 translate="common.bookingMode.Free"
                 (click)="adaptFormDependingOnBookingMode(BookingMode.Free)"
                 (keyup)="adaptFormDependingOnBookingMode(BookingMode.Free)"></label>

          <input class="btn-check" type="radio"
                 [formControl]="bookingMode"
                 [value]="BookingMode.Slots">
          <label class="btn btn-toggle btn-toggle-right h-auto"
                 [ngClass]="{ active: bookingMode.value === BookingMode.Slots }"
                 translate="common.bookingMode.Slots"
                 (click)="adaptFormDependingOnBookingMode(BookingMode.Slots)"
                 (keyup)="adaptFormDependingOnBookingMode(BookingMode.Slots)"></label>
        </div>
      </div>

      <app-form-error [control]="bookingMode"></app-form-error>
    </div>

    <!-- Initial duration -->
    @if (bookingMode.value === BookingMode.Free) {
      <div class="col-12 col-md-4">
        <label class="form-label"
               for="initialBookingDuration">{{ 'services.booking.initialBookingDuration' | translate }}*</label>
        <input class="form-control" id="initialBookingDuration" name="initialBookingDuration" type="number"
               [formControl]="initialBookingDuration"
               [min]="1"
               (keydown)="FormUtils.validateInputNumberLength($event, 5)">
        <app-form-error [control]="duration"></app-form-error>
        <app-form-error [control]="initialBookingDuration"></app-form-error>
      </div>

      <!-- Max duration -->
      <div class="col-12 col-md-4">
        <label class="form-label" for="maxBookingDuration">{{ 'services.booking.maxBookingDuration' | translate }}
          *</label>
        <input class="form-control" id="maxBookingDuration" name="maxBookingDuration" type="number"
               [formControl]="maxBookingDuration"
               [min]="1"
               (keydown)="FormUtils.validateInputNumberLength($event, 5)">
        <app-form-error [control]="maxBookingDuration"></app-form-error>
      </div>

      <!-- Booking Duration Unit -->
      <div class="col-12 col-md-4">
        <label class="form-label" for="bookingTimeUnit">{{ 'common.unit' | translate }}*</label>
        <select class="form-control form-select" name="bookingTimeUnit" id="bookingTimeUnit"
                formControlName="bookingTimeUnit">
          @for (bookingTimeUnit of bookingTimeUnits; track bookingTimeUnit) {
            <option
              [ngValue]="bookingTimeUnit">{{ 'common.bookingTimeUnit.' + bookingTimeUnit | translate }}
            </option>
          }
        </select>
        <app-form-error [control]="bookingTimeUnit"></app-form-error>
      </div>


      <div class="col-12 col-md-6">
        <label class="form-label"
               for="maximumBookingAdvanceTimeInDay">{{ 'services.booking.maximumBookingAdvanceTimeInDay' | translate }}</label>
        <input class="form-control" id="maximumBookingAdvanceTimeInDay" name="maximumBookingAdvanceTimeInDay"
               type="number"
               [formControl]="maximumBookingAdvanceTimeInDay"
               (keydown)="FormUtils.validateInputNumberLength($event, 4)">
        <app-form-error [control]="maximumBookingAdvanceTimeInDay"></app-form-error>
      </div>


      <!-- Max simultaneous Booking by User -->

      <div class="col-12 col-md-6">
        <label class="form-label"
               for="maxNumberOfSimultaneousBookingByCustomer">{{ 'services.booking.maxNumberOfSimultaneousBookingByCustomer' | translate }}
          *</label>
        <input class="form-control" id="maxNumberOfSimultaneousBookingByCustomer"
               name="maxNumberOfSimultaneousBookingByCustomer" type="number"
               [formControl]="maxNumberOfSimultaneousBookingByCustomer"
               (keydown)="FormUtils.validateInputNumberLength($event, 4)">
        <app-form-error [control]="maxNumberOfSimultaneousBookingByCustomer"></app-form-error>
      </div>
    }

    <!-- Max planned Booking by User -->
    <div class="col-12 col-md-6">
      <label class="form-label"
             for="maxNumberOfPlannedBookingByCustomer">{{ 'services.booking.maxNumberOfPlannedBookingByCustomer' | translate }}
        *</label>

      <input class="form-control" id="maxNumberOfPlannedBookingByCustomer" name="maxNumberOfPlannedBookingByCustomer"
             type="number"
             [formControl]="maxNumberOfPlannedBookingByCustomer"
             (keydown)="FormUtils.validateInputNumberLength($event, 4)">
      <app-form-error [control]="maxNumberOfPlannedBookingByCustomer"></app-form-error>
    </div>

  </div>

  <div class="row">

    <!-- Cancellation/Modification delay -->
    <div class="col-12 col-md-6">
      <label class="form-label"
             for="deadlineForUpdatingBeforeBookingPeriod">{{ 'services.booking.deadlineForUpdatingBeforeBookingPeriod' | translate }}
        *</label>

      <input class="form-control" id="deadlineForUpdatingBeforeBookingPeriod"
             name="deadlineForUpdatingBeforeBookingPeriod" type="number"
             [formControl]="deadlineForUpdatingBeforeBookingPeriod"
             (keydown)="FormUtils.validateInputNumberLength($event, 5)">
      <app-form-error [control]="deadlineForUpdatingBeforeBookingPeriod"></app-form-error>
    </div>

    <div class="col-12 col-md-6">
      <label class="form-label" for="deadlineForUpdatingBeforeBookingPeriodTimeUnit">{{ 'common.unit' | translate }}
        *</label>

      <select class="form-control form-select" name="deadlineForUpdatingBeforeBookingPeriodTimeUnit"
              id="deadlineForUpdatingBeforeBookingPeriodTimeUnit"
              formControlName="deadlineForUpdatingBeforeBookingPeriodTimeUnit">
        @for (bookingTimeUnit of bookingTimeUnitsExceptMonthAndYear; track bookingTimeUnit) {
          <option
            [ngValue]="bookingTimeUnit">{{ 'common.bookingTimeUnit.' + bookingTimeUnit | translate }}
          </option>
        }
      </select>
      <app-form-error [control]="bookingTimeUnit"></app-form-error>
    </div>

    @if (bookingMode.value === BookingMode.Free) {
      <div class="col-12">
        <div class="form-check form-switch mt-4">
          <input class="form-check-input" id="recurrentBookingAvailable" type="checkbox"
                 name="recurrentBookingAvailable"
                 formControlName="recurrentBookingAvailable">
          <label class="form-check-label" for="recurrentBookingAvailable"
                 translate="services.booking.allowRecurrentBooking"></label>
        </div>
      </div>
    }

  </div>

  <div class="row">

    <h5 class="my-4" translate="services.booking.displaySubtitle"></h5>

    <div class="col-12 col-md-6">
      <label class="form-label" for="defaultCalendarDisplayMode">
        {{ 'services.booking.calendarMode' | translate }}*
      </label>
      <select class="form-select" id="defaultCalendarDisplayMode" [formControl]="defaultCalendarDisplayMode">
        @for (bookingCalendarMode of bookingCalendarModes; track bookingCalendarMode) {
          <option
            [ngValue]="bookingCalendarMode">{{ 'common.bookingCalendarMode.' + bookingCalendarMode | translate }}
          </option>
        }
      </select>
    </div>

    <div class="col-12 col-md-6">
      <label class="form-label" translate="services.booking.informationsToDisplayInBooking"></label>

      <div class="form-check form-switch">
        <input class="form-check-input" id="displayCustomerCards" type="checkbox" name="displayCustomerCards"
               formControlName="displayCustomerCards">
        <label class="form-check-label" for="recurrentBookingAvailable"
               translate="services.booking.displayCustomerCards"></label>
      </div>

      <div class="form-check form-switch">
        <input class="form-check-input" id="displayCustomerBoats" type="checkbox" name="displayCustomerBoats"
               formControlName="displayCustomerBoats">
        <label class="form-check-label" for="displayCustomerBoats" translate="services.booking.displayCustomerBoats"></label>
      </div>
    </div>

  </div>

  <div class="btn-bar">
    <button class="btn btn-primary" type="submit"
            [disabled]="bookingForm.invalid || bookingForm.pristine"
            (click)="saveBookingConfig()"
            translate="services.booking.saveBookingConfig">
    </button>
  </div>
</div>
